

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class ConfigOptionDataService extends DataService<typeof Model.Core.Logic.ViewModels.ConfigOptionItem, Model.Core.Logic.ViewModels.ConfigOptionItem, ConfigOptionItem> {
	protected map(entity: Model.Core.Logic.ViewModels.ConfigOptionItem): ConfigOptionItem {
		return new ConfigOptionItemModel(entity);
	}

	public static make(context?: any): ConfigOptionDataService {
		return new ConfigOptionDataService(context, ctx => ctx.ConfigOptions);
	}

	public addKey(key: string[]) {
		for (const k of key) {
			if (this.items.every(i => i.key !== k)) {
				this.create(() => new Model.Core.Logic.ViewModels.ConfigOptionItem({
					key: k,
					value: null,
				}));
			}
		}
	}
	
}

export class ConfigOptionItemModel extends EntityModel<Model.Core.Logic.ViewModels.ConfigOptionItem, ConfigOptionItem> implements ConfigOptionItem {
	@property<ConfigOptionItemModel>(o => o.entity.key, (o, value) => o.entity.key = value)
	public key: string;

	@property<ConfigOptionItemModel>(o => o.entity.value, (o, value) => o.entity.value = value)
	public value: string;

}




// WEBPACK FOOTER //
// ./src/app/general/config-option/form/config-option-form.data.ts